/**
 * @generated SignedSource<<f83c56b22a1f57dac9aea785b1a778d8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LegalClassification = "ARTS" | "EMTS" | "NONE" | "OTHER";
export type TransactionCategory = "CORPORATE_ACTION" | "CRYPTO_ACTION" | "CRYPTO_TRANSFER" | "FIAT_TRANSFER" | "NON_USER_INITIATED" | "STAKING" | "TRADE";
export type TransactionDirection = "INCOMING" | "OUTGOING";
export type TransactionStatus = "CANCELED" | "CREATED" | "CREDITED" | "EXPIRED" | "FAILED" | "FINISHED" | "IN_PROGRESS" | "REFUNDED" | "REJECTED";
export type CryptoActionViewQuery$variables = {
  id: string;
};
export type CryptoActionViewQuery$data = {
  readonly cryptoAction: {
    readonly __typename: string;
    readonly category: TransactionCategory;
    readonly childrenTransactions?: ReadonlyArray<{
      readonly asset: {
        readonly id: string;
        readonly legalClassification: LegalClassification | null | undefined;
        readonly logoUrl: string | null | undefined;
        readonly name: string | null | undefined;
        readonly symbol: string | null | undefined;
      } | null | undefined;
      readonly assetAmount: PrecisionFloat | null | undefined;
      readonly direction: TransactionDirection | null | undefined;
      readonly fiat: {
        readonly id: string;
        readonly name: string | null | undefined;
        readonly symbol: string | null | undefined;
      } | null | undefined;
      readonly fiatAmount: PrecisionFloat | null | undefined;
      readonly id: string;
    }> | null | undefined;
    readonly id: string;
    readonly status: TransactionStatus | null | undefined;
    readonly time: TimeScalar | null | undefined;
  } | null | undefined;
};
export type CryptoActionViewQuery = {
  response: CryptoActionViewQuery$data;
  variables: CryptoActionViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Fiat",
  "kind": "LinkedField",
  "name": "fiat",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatAmount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legalClassification",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetAmount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "direction",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CryptoActionViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "cryptoAction",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "childrenTransactions",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "asset",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v7/*: any*/),
                      (v11/*: any*/),
                      (v8/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "MergerCryptoTransaction",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CryptoActionViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "cryptoAction",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "childrenTransactions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "asset",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v7/*: any*/),
                      (v11/*: any*/),
                      (v8/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "MergerCryptoTransaction",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "35653e49544588b7ebb4d1ff9ae9030e",
    "id": null,
    "metadata": {},
    "name": "CryptoActionViewQuery",
    "operationKind": "query",
    "text": "query CryptoActionViewQuery(\n  $id: ID!\n) {\n  cryptoAction(id: $id) {\n    __typename\n    id\n    category\n    status\n    time\n    ... on MergerCryptoTransaction {\n      childrenTransactions {\n        __typename\n        id\n        fiat {\n          id\n          name\n          symbol\n        }\n        fiatAmount\n        asset {\n          __typename\n          id\n          name\n          logoUrl\n          symbol\n          legalClassification\n        }\n        assetAmount\n        direction\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "66f0e8be9baa4f437996383b24d67ec4";

export default node;
